function buildSearchParams(search = "") {
  return new URLSearchParams(String(search || "").replace(/^\?/, ""));
}

const HANDOFF_QUERY_PARAM_KEY = "handoff";
const HANDOFF_READY_PARAM_KEY = "handoffReady";
const HANDOFF_TOKEN_KEY = "mincool.onboardingHandoffToken";
const SCRUBBED_HANDOFF_TOKEN_KEY = "__mincoolOnboardingHandoffTokenFromUrl";

export function readSupportEmailClaimToken(search = "") {
  try {
    const params = buildSearchParams(search);
    return String(
      params.get("claim") || params.get("emailClaim") || params.get("supportToken") || "",
    ).trim();
  } catch {
    return "";
  }
}

export function readSupportEmailClaimCallback(search = "") {
  try {
    return String(buildSearchParams(search).get("supportClaim") || "").trim() === "1";
  } catch {
    return false;
  }
}

export function resolvePlainLinkedAuthHandoffToken({
  isSignInSurface = false,
  hasSupportEmailClaim = false,
  hasSupportEmailClaimCallback = false,
  handoffToken = "",
} = {}) {
  return isSignInSurface || hasSupportEmailClaim || hasSupportEmailClaimCallback
    ? ""
    : String(handoffToken || "").trim();
}

export function scrubOnboardingHandoffTokenFromUrl(win = globalThis.window) {
  if (!win?.location?.search || !win.history?.replaceState) return "";
  let token = "";
  try {
    const url = new URL(`${win.location.pathname || "/"}${win.location.search}${win.location.hash || ""}`, win.location.origin || "https://min.cool");
    token = String(url.searchParams.get(HANDOFF_QUERY_PARAM_KEY) || "").trim();
    if (!token) return "";
    url.searchParams.delete(HANDOFF_QUERY_PARAM_KEY);
    url.searchParams.set(HANDOFF_READY_PARAM_KEY, "1");
    win.history.replaceState(win.history.state || null, "", `${url.pathname}${url.search}${url.hash}`);
  } catch {
    return "";
  }
  for (const storeName of ["localStorage", "sessionStorage"]) {
    try {
      win[storeName]?.setItem(HANDOFF_TOKEN_KEY, token);
    } catch {
      // Storage can be disabled while URL scrubbing still needs to succeed.
    }
  }
  try {
    win[SCRUBBED_HANDOFF_TOKEN_KEY] = token;
  } catch {
    // Non-extensible window-like test doubles can still use the scrubbed URL.
  }
  return token;
}

export function readScrubbedOnboardingHandoffToken(win = globalThis.window) {
  return String(win?.[SCRUBBED_HANDOFF_TOKEN_KEY] || "").trim();
}

export function readStoredLinkedAuthHandoffToken(search = "", win = globalThis.window) {
  try {
    if (String(buildSearchParams(search).get(HANDOFF_READY_PARAM_KEY) || "") !== "1") return "";
  } catch {
    return "";
  }
  for (const storeName of ["sessionStorage", "localStorage"]) {
    try {
      const token = String(win?.[storeName]?.getItem(HANDOFF_TOKEN_KEY) || "").trim();
      if (token) return token;
    } catch {
      // Storage can disappear between reload and auth render.
    }
  }
  return "";
}
